<nb-card class="tabs-card">
    <nb-card-body>
      <div class="text-center image">
        <img
          class="card-img-top"
          [src]="card.imagePath"
        />

        <!-- More section  -->
        <a
          class="nav-item nav-link"
          type="button"
          (click)="toggleMore($event)"
        >
          <nb-icon icon="more-horizontal-outline"></nb-icon>
        </a>

        <!-- Dropdown for more  -->
        <nb-card
          [size]="'medium'"
          *ngIf="card.dropped"
          class="more-dropdown"
          (click)="$event.stopPropagation()"
        >
          <nb-card-body>
            <nb-list>
              <nb-list-item>
                <p>ویرایش</p>
                <p>انتقال به</p>
                <p>مجوزها</p>
                <p>تغییر نام</p>
                <p>تغییر عکس</p>
                <p>غیرفعال</p>
                <p>حذف</p>
              </nb-list-item>
            </nb-list>
          </nb-card-body>
        </nb-card>
      </div>
      <div class="card-body">
        <div class="d-flex align-items-center">
          <h5 class="card-title">{{ card.name }}</h5>
          <nb-icon [ngClass]="{
            show: card.favorite,
            hide: !card.favorite
          }" class="star me-auto" [icon]="starIcon(card.favorite)" (click)="onStarClick($event)"></nb-icon>
        </div>
        <div class="d-flex" >
          <!-- <nb-icon icon="edit-outline"></nb-icon> -->
          <morva-icons icon="clock"></morva-icons>
          <span class="card-text">{{ card.updateTime }}</span>
          <morva-icons class="me-3" icon="view"></morva-icons>
          <span class="card-text me-1">{{ card.view }}</span>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
